











import Popup from '@/views/organisms/Popup.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import moment from 'moment'
import Global from '@/common/global.js'

export default
  components: {
    Popup
    BlueButton
  }

  props:
    previewData:
      type: Object
      defalt: {}
    supplySource:
      type: String
      defalt: ''

  data: () ->
    toDay: moment().format('yyyy/MM/DD')
    supplySourceList: Global.supplySource()

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
    returnText: (text) -> 
      text = text.replaceAll('{{plan_date}}', @toDay)
      for row, index in @supplySourceList
        if row.id == Number(@supplySource)
          text = text.replaceAll('{{supply_source}}', row.name)
      text = text.replaceAll('{{laboratory_name}}', '〇〇研究室')
      text = text.replaceAll('{{name}}', '中野')
      text = text.replaceAll('{{container_type}}', '自前')
      text = text.replaceAll('{{capacity}}', '50L')
      text = text.replaceAll('{{remarks}}', 'TEL不要')
      return text
  }
